/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';
import { isGroundStation } from '../../../modules/checkDeployEnv';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

const sendVerificationEmail = async emailAddress => {
  try {
    await methodPromise('users.sendVerificationEmail');
    Bert.alert(`Verification sent to ${emailAddress}!`, 'success');
  } catch (error) {
    handleErrorInClient(error);
  }
};

const verifyEmailAlert = emailAddress => (
  <Alert variant="warning">
    Hey friend! Can you <strong>verify your email address</strong> ({emailAddress}) for us?{' '}
    <Alert.Link onClick={() => sendVerificationEmail(emailAddress)} href="#">
      Re-send verification email
    </Alert.Link>
  </Alert>
);

class Authenticated extends React.Component {
  constructor(props) {
    super(props);
    if (Meteor.isClient) {
      const { setAfterLoginPath } = this.props;
      setAfterLoginPath(`${window.location.pathname}${window.location.search}`);
    }
  }

  render() {
    const {
      loggingIn,
      authenticated,
      component,
      emailVerified,
      emailAddress,
      path,
      exact,
      deployEnv,
      ...rest
    } = this.props;
    return (
      <Route
        path={path}
        exact={exact}
        render={props => {
          let emailVerifiedComponent = '';
          if (emailVerified || isGroundStation(deployEnv)) {
            emailVerifiedComponent = React.createElement(component, {
              ...props,
              ...rest,
              loggingIn,
              emailVerified,
              emailAddress,
              deployEnv
            });
          } else {
            emailVerifiedComponent = verifyEmailAlert(emailAddress);
          }

          if (authenticated) {
            return emailVerifiedComponent;
          }
          return <Redirect to="/login" />;
        }}
      />
    );
  }
}

Authenticated.defaultProps = {
  path: '',
  exact: false,
  emailAddress: '',
  isAdmin: false
};

Authenticated.propTypes = {
  path: PropTypes.string,
  exact: PropTypes.bool,
  loggingIn: PropTypes.bool.isRequired,
  authenticated: PropTypes.bool.isRequired,
  emailAddress: PropTypes.string,
  emailVerified: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
  setAfterLoginPath: PropTypes.func.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default Authenticated;
